import { axiosConfig } from '../api/axios-config.js'

// 機構帳號
export const user = {
  // 取得清單
  get: (id, token) => axiosConfig.get(`/api/user/${id || ''}`, token),

  //  創建
  create: (data, token) => axiosConfig.post('/api/user', data, token),

  // 更新
  update: (id, data, token) => axiosConfig.patch(`/api/user/${id}`, data, token),

  // 重置密碼
  resetPassword: (id, token) => axiosConfig.put(`/api/user/${id}/password`, '', token),

  // 更改狀態
  changeStatus: (id, data, token) => axiosConfig.put(`/api/user/${id}`, data, token),

  updateAgencyAccess: (id, data, token) => axiosConfig.patch(`/api/user/${id}/agency`, data, token),
}
